import { render, staticRenderFns } from "./CustomRCTextarea.vue?vue&type=template&id=4d572ab3&scoped=true"
import script from "./CustomRCTextarea.vue?vue&type=script&lang=js"
export * from "./CustomRCTextarea.vue?vue&type=script&lang=js"
import style0 from "./CustomRCTextarea.vue?vue&type=style&index=0&id=4d572ab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d572ab3",
  null
  
)

export default component.exports